var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings tw-w-full"},[_c('app-heading',{staticClass:"tw-text-h2 tw-m-0"},[_vm._v(" Account Settings ")]),_c('account-user-profile'),_c('account-contact-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }